"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getMakeFee = void 0;
var is_nft_1 = require("./is-nft");
function getMakeFee(fees, order) {
    if (order.type === "RARIBLE_V2") {
        return getMakeFeeV2(fees, order);
    }
    else {
        return 0;
    }
}
exports.getMakeFee = getMakeFee;
function getMakeFeeV2(fees, order) {
    //todo fee may be lower than this (if take is not NFT too)
    if (!is_nft_1.isNft(order.make.assetType)) {
        if (order.data.dataType !== "RARIBLE_V2_DATA_V1") {
            throw new Error("Type " + order.data.dataType + " not supported for V2 orders");
        }
        var originFees = order.data.originFees.map(function (f) { return f.value; }).reduce(function (v, acc) { return v + acc; }, 0);
        return fees.v2 + originFees;
    }
    else {
        return 0;
    }
}
